import React from 'react';
import AiMlIntro from '../components/AiMlIntro/AiMlIntro';
import AiMlWhyChoose from '../components/AiMlWhyChoose/AiMlWhyChoose';
import CtaSection from '../components/CtaSection/CtaSection'; // Import CTA

const AiMlPage = () => {
  return (
    <>
      <AiMlIntro />
      <AiMlWhyChoose />
      <CtaSection />
    </>
  );
};

export default AiMlPage;
